export default function CardBase({ children, styleClass, onClick }) {
  return (
    <div onClick={onClick} className={`mt-6 ${styleClass} shadow rounded-xl`}>
      {children}
    </div>
  );
}
